import "./style/loader.css"

// https://loading.io/css/
const Loader = () => {
  return <div className="lds-ring">
    <div/><div/><div/>
  </div>
}

export default Loader;

export const SmallLoader = () => {
  return <div className="lds-ring small">
    <div/><div/><div/>
  </div>
}
